import { render, staticRenderFns } from "./get_behavioural.vue?vue&type=template&id=7cf033d6&scoped=true&"
import script from "./get_behavioural.vue?vue&type=script&lang=js&"
export * from "./get_behavioural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf033d6",
  null
  
)

export default component.exports